<template>
  <div>
    <el-input
      prefix-icon="iconfont icon-mima"
      :type="eyesClosed?'password':'text'"
      placeholder="Password"
      v-model="childPass"
      @change="$emit('change', $event)"
    >></el-input>
    <img
      class="eyes"
      @click="eyesClosed = false"
      v-if="eyesClosed"
      src="@/assets/img/eyes_close.png"
      alt
    />
    <img class="eyes" @click="eyesClosed = true" v-else src="@/assets/img/eyes.png" alt />
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default() {
        return ''
      },
    },
  },
  model: {
    prop: 'content',
    event: 'change',
  },

  watch: {
    content(newval) {
      this.childPass = newval
    },
  },
  data() {
    return {
      childPass: '',
      eyesClosed: true,
    }
  },
  created() {
    this.childPass = this.content
  },
}
</script>

<style scoped lang="less">
.eyes {
  height: 20px;
  width: 20px;
  position: absolute;
  right: 10px;
  top: 10px;
}
</style>